import { registerPlugin } from '@capacitor/core';
import { Capacitor } from '@capacitor/core';

const AppReview = registerPlugin<{
  requestReview(): Promise<void>;
}>('AppReview');

const STORAGE_KEY = 'rostfound_review_prompted';

/**
 * Request App Store rating at the "aha" moment:
 * - First time seeing overlaps with friends
 * - First meetup initiated
 * Only fires once per install, native only.
 */
export async function maybeRequestReview(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  if (localStorage.getItem(STORAGE_KEY)) return;

  localStorage.setItem(STORAGE_KEY, Date.now().toString());
  await AppReview.requestReview();
}
